import { createSelector } from '@reduxjs/toolkit'
import { includes, values, pickBy, sortBy, filter } from 'lodash'
import TimetoastTemporal from '@base/timetoast_temporal.js'
import { getMarkers } from './marker_selectors.js'
import { getTimespans } from './timespan_selectors.js'

const timelineItemDateSorterFn = function (item) {
  const string = item.date || item.start_date
  return TimetoastTemporal.parse(string).getTime()
}

export function getTimelines(state, props) {
  return state.data.timelines
}

export function getTimeline(state, props) {
  const { timelineId } = props
  const idString = timelineId.toString()
  const timeline = state.data.timelines[idString]
  return timeline
}

export const timelineMarkersSelector = createSelector([getTimeline, getMarkers], function (timeline, allMarkers) {
  return pickBy(allMarkers, item => includes(timeline.marker_ids, item.id))
})

export const timelineMarkersListSelector = createSelector(
  [(state, props) => timelineMarkersSelector(state, props)],
  function (timelineMarkers) {
    return values(timelineMarkers)
  }
)

export const timelineTimespansSelector = createSelector([getTimeline, getTimespans], function (timeline, allTimespans) {
  const ids = timeline.timespan_ids
  return pickBy(allTimespans, item => includes(ids, item.id))
})

export const timelineTimespansListSelector = createSelector(
  [(state, props) => timelineTimespansSelector(state, props)],
  function (timelineTimespans) {
    return values(timelineTimespans)
  }
)

export const timelineItemsListSelector = createSelector(
  [getTimeline, getMarkers, getTimespans],
  function (timeline, allMarkers, allTimespans) {
    const markerIds = timeline.marker_ids
    const timespanIds = timeline.timespan_ids

    // filter all markers and timespans to get only those of the timeline
    const filteredMarkers = filter(values(allMarkers), item => includes(markerIds, item.id))
    const filteredTimespans = filter(values(allTimespans), item => includes(timespanIds, item.id))

    // combine the two arrays
    const allItems = filteredMarkers.concat(filteredTimespans)
    // define the function to sort the items by
    // actually perform the sort
    const sortedItems = sortBy(allItems, [timelineItemDateSorterFn])
    // and return the sorted array
    return sortedItems
  }
)
